export function getOpenseaTokenUrl(hash: string, tokenId: string) {
  const isProduction = process.env.REACT_APP_STATUS_ENV === 'prod'

  if (isProduction) {
    return `https://opensea.io/assets/base/${hash}/${tokenId}`
  }

  return `https://testnets.opensea.io/assets/base_sepolia/${hash}/${tokenId}`
}
